(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sana-looks-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlv(section) {
    if (section.dataset.slvReady) return;
    section.dataset.slvReady = '1';

    var viewport = section.querySelector('[data-slv-viewport]');
    var prevBtn  = section.querySelector('[data-slv-prev]');
    var nextBtn  = section.querySelector('[data-slv-next]');
    var dots     = Array.from(section.querySelectorAll('[data-slv-dot]'));
    var slides   = Array.from(section.querySelectorAll('[data-slv-slide]'));
    var videos   = Array.from(section.querySelectorAll('video'));
    if (!viewport) return;

    var autoplay      = section.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) || 4000;
    var autoplayTimer = null;
    var isDragging = false, dragStartX = 0, dragStartScroll = 0, dragMoved = false;

    function slideWidth() {
      if (!slides[0]) return viewport.clientWidth;
      return slides[0].offsetWidth + parseInt(getComputedStyle(section).getPropertyValue('--slv-gap') || '16', 10);
    }
    function updateState() {
      var sl = viewport.scrollLeft;
      var max = viewport.scrollWidth - viewport.clientWidth;
      if (prevBtn) prevBtn.disabled = sl < 2;
      if (nextBtn) nextBtn.disabled = sl > max - 2;
      var idx = Math.round(sl / slideWidth());
      dots.forEach(function (d, i) { d.classList.toggle('slv__dot--active', i === idx); });
    }
    viewport.addEventListener('scroll', updateState, { passive: true });
    updateState();

    if (prevBtn) prevBtn.addEventListener('click', function () {
      resetAutoplay();
      viewport.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      resetAutoplay();
      viewport.scrollBy({ left: slideWidth(), behavior: 'smooth' });
    });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        resetAutoplay();
        viewport.scrollTo({ left: slideWidth() * parseInt(this.dataset.slvDot, 10), behavior: 'smooth' });
      });
    });

    viewport.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      isDragging = true; dragMoved = false;
      dragStartX = e.pageX; dragStartScroll = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
    });
    document.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      var dx = e.pageX - dragStartX;
      if (Math.abs(dx) > 5) dragMoved = true;
      viewport.scrollLeft = dragStartScroll - dx;
    });
    document.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      viewport.classList.remove('is-dragging');
    });
    viewport.addEventListener('click', function (e) {
      if (dragMoved) { e.preventDefault(); e.stopPropagation(); dragMoved = false; }
    }, true);

    function startAutoplay() {
      if (!autoplay) return;
      clearInterval(autoplayTimer);
      autoplayTimer = setInterval(function () {
        var max = viewport.scrollWidth - viewport.clientWidth;
        if (viewport.scrollLeft >= max - 2) viewport.scrollTo({ left: 0, behavior: 'smooth' });
        else viewport.scrollBy({ left: slideWidth(), behavior: 'smooth' });
      }, autoplaySpeed);
    }
    function resetAutoplay() { clearInterval(autoplayTimer); startAutoplay(); }
    startAutoplay();
    section.addEventListener('mouseenter', function () { clearInterval(autoplayTimer); });
    section.addEventListener('mouseleave', startAutoplay);

    // Vidéos : la source n'est chargée qu'à la première apparition, lecture seulement quand visible
    videos.forEach(function (v) {
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.removeAttribute('controls');
    });
    // Flux adaptatif (HLS) : chaque carte charge une qualité adaptée à sa taille, pas le 1080p complet
    var hlsLib = section.dataset.hlsLib;
    function loadHlsLib(cb) {
      if (window.Hls) return cb();
      if (!hlsLib) return cb();
      if (window.__slvHlsCbs) { window.__slvHlsCbs.push(cb); return; }
      window.__slvHlsCbs = [cb];
      var sc = document.createElement('script');
      sc.src = hlsLib;
      sc.async = true;
      sc.onload = sc.onerror = function () {
        var cbs = window.__slvHlsCbs; window.__slvHlsCbs = null;
        cbs.forEach(function (f) { f(); });
      };
      document.head.appendChild(sc);
    }
    function attachSource(v, done) {
      if (v.dataset.slvAttached) return done();
      v.dataset.slvAttached = '1';
      var hlsUrl = v.dataset.slvHls, mp4 = v.dataset.slvSrc;
      var nativeHls = v.canPlayType('application/vnd.apple.mpegurl');
      if (!hlsUrl) { v.src = mp4; v.load(); return done(); }
      loadHlsLib(function () {
        if (window.Hls && window.Hls.isSupported()) {
          var hls = new window.Hls({
            capLevelOnFPSDrop: true,
            maxBufferLength: 8,
            maxMaxBufferLength: 16,
            startLevel: 0
          });
          // Qualité plafonnée à la taille réelle de la carte (petit côté de la vidéo ≥ largeur affichée × 1,5)
          hls.on(window.Hls.Events.MANIFEST_PARSED, function () {
            var target = (v.clientWidth || 300) * Math.min(window.devicePixelRatio || 1, 1.5);
            var cap = hls.levels.length - 1;
            for (var i = 0; i < hls.levels.length; i++) {
              var l = hls.levels[i];
              if (Math.min(l.width || 0, l.height || 0) >= target) { cap = i; break; }
            }
            hls.autoLevelCapping = cap;
          });
          hls.on(window.Hls.Events.ERROR, function (ev, data) {
            if (data && data.fatal) { hls.destroy(); v.src = mp4; v.load(); v.play().catch(function () {}); }
          });
          hls.loadSource(hlsUrl);
          hls.attachMedia(v);
          v._slvHls = hls;
        } else if (nativeHls) {
          v.src = hlsUrl; v.load();
        } else {
          v.src = mp4; v.load();
        }
        done();
      });
    }
    function playVideo(v) {
      v.dataset.slvWant = '1';
      attachSource(v, function () {
        if (v.dataset.slvWant !== '1') return;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    }
    function pauseVideo(v) {
      v.dataset.slvWant = '0';
      v.pause();
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) playVideo(en.target);
          else pauseVideo(en.target);
        });
      }, { threshold: 0.5 });
      videos.forEach(function (v) { io.observe(v); });
    } else {
      videos.forEach(playVideo);
    }
  }

  function initAll() { document.querySelectorAll('.slv').forEach(initSlv); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.slv');
    if (s) initSlv(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["votrestyle"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.stl').forEach(function (section) {
    var viewport  = section.querySelector('[data-stl-viewport]');
    var prevBtn   = section.querySelector('[data-stl-prev]');
    var nextBtn   = section.querySelector('[data-stl-next]');
    var dots      = Array.from(section.querySelectorAll('[data-stl-dot]'));
    var slides    = Array.from(section.querySelectorAll('[data-stl-slide]'));
    var hotspots  = Array.from(section.querySelectorAll('[data-stl-hotspot]'));

    if (!viewport) return;

    var autoplay      = section.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) || 4000;
    var autoplayTimer = null;
    var isDragging    = false;
    var dragStartX    = 0;
    var dragStartScroll = 0;
    var dragMoved     = false;

    function slideWidth() {
      if (!slides[0]) return viewport.clientWidth;
      return slides[0].offsetWidth + parseInt(getComputedStyle(section).getPropertyValue('--stl-gap') || '16', 10);
    }

    function updateState() {
      var sl = viewport.scrollLeft;
      var max = viewport.scrollWidth - viewport.clientWidth;
      if (prevBtn) prevBtn.disabled = sl < 2;
      if (nextBtn) nextBtn.disabled = sl > max - 2;
      var idx = Math.round(sl / slideWidth());
      dots.forEach(function (d, i) { d.classList.toggle('stl__dot--active', i === idx); });
    }

    viewport.addEventListener('scroll', updateState, { passive: true });
    updateState();

    if (prevBtn) prevBtn.addEventListener('click', function () {
      resetAutoplay();
      viewport.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      resetAutoplay();
      viewport.scrollBy({ left: slideWidth(), behavior: 'smooth' });
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        resetAutoplay();
        viewport.scrollTo({ left: slideWidth() * parseInt(this.dataset.stlDot, 10), behavior: 'smooth' });
      });
    });

    viewport.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      isDragging = true;
      dragMoved  = false;
      dragStartX = e.pageX;
      dragStartScroll = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
    });
    document.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      var dx = e.pageX - dragStartX;
      if (Math.abs(dx) > 5) dragMoved = true;
      viewport.scrollLeft = dragStartScroll - dx;
    });
    document.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      viewport.classList.remove('is-dragging');
    });
    viewport.addEventListener('click', function (e) {
      if (dragMoved) { e.preventDefault(); e.stopPropagation(); dragMoved = false; }
    }, true);

    function startAutoplay() {
      if (!autoplay) return;
      autoplayTimer = setInterval(function () {
        var max = viewport.scrollWidth - viewport.clientWidth;
        if (viewport.scrollLeft >= max - 2) {
          viewport.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          viewport.scrollBy({ left: slideWidth(), behavior: 'smooth' });
        }
      }, autoplaySpeed);
    }
    function resetAutoplay() { clearInterval(autoplayTimer); startAutoplay(); }
    startAutoplay();
    section.addEventListener('mouseenter', function () { clearInterval(autoplayTimer); });
    section.addEventListener('mouseleave', startAutoplay);

    var hasHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function closeAll() {
      hotspots.forEach(function (hs) {
        hs.classList.remove('is-active');
        var trigger = hs.querySelector('[data-stl-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        var card = hs.querySelector('[data-stl-card]');
        if (card) card.setAttribute('aria-hidden', 'true');
      });
    }

    function openHS(hs) {
      closeAll();
      hs.classList.add('is-active');
      var trigger = hs.querySelector('[data-stl-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      var card = hs.querySelector('[data-stl-card]');
      if (card) card.setAttribute('aria-hidden', 'false');
    }

    hotspots.forEach(function (hs) {
      var trigger = hs.querySelector('[data-stl-trigger]');
      var card    = hs.querySelector('[data-stl-card]');
      var closeTimer = null;

      function scheduleClose() {
        closeTimer = setTimeout(closeAll, 150);
      }
      function cancelClose() {
        clearTimeout(closeTimer);
      }

      if (trigger) {
        trigger.addEventListener('click', function (e) {
          e.stopPropagation();
          cancelClose();
          hs.classList.contains('is-active') ? closeAll() : openHS(hs);
        });

        if (hasHover) {
          hs.addEventListener('mouseenter', function () {
            cancelClose();
            openHS(hs);
          });
          hs.addEventListener('mouseleave', function () {
            scheduleClose();
          });
        }
      }

      if (card) {
        card.addEventListener('click', function (e) { e.stopPropagation(); });
        if (hasHover) {
          card.addEventListener('mouseenter', function () { cancelClose(); });
          card.addEventListener('mouseleave', function () { scheduleClose(); });
        }
      }
    });

    viewport.addEventListener('scroll', closeAll, { passive: true });
    document.addEventListener('click', closeAll);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
